"use client";

import type { HTMLAttributes, PropsWithChildren } from "react";

import ImgBgResponsiveRender from "./ImgBgResponsiveRender";
import ImgBgResponsiveLazy from "./ImgBgResponsiveLazy";

export interface ImgBgResponsiveProps extends HTMLAttributes<HTMLElement> {
  imageUrl: string;
  lazy?: "eager" | "lazy";
  prefetch?: boolean;
  triggers?: string[];
  forceFallback?: boolean;
}

function ImgBgResponsive({
  lazy = "lazy",
  children,
  imageUrl,
  className,
  prefetch = true,
  forceFallback = false,
  style,
  triggers,
  ...attrs
}: PropsWithChildren<ImgBgResponsiveProps>) {
  if (lazy === "eager") {
    return (
      <ImgBgResponsiveRender
        imageUrl={imageUrl}
        lazy={lazy}
        prefetch={prefetch}
        style={style}
        loadImage={true}
        className={className}
        {...attrs}
      >
        {children}
      </ImgBgResponsiveRender>
    );
  }

  return (
    <ImgBgResponsiveLazy
      imageUrl={imageUrl}
      lazy={lazy}
      prefetch={prefetch}
      forceFallback={forceFallback}
      style={style}
      triggers={triggers}
      className={className}
      {...attrs}
    >
      {children}
    </ImgBgResponsiveLazy>
  );
}

export default ImgBgResponsive;
